import { AppRoute } from '@agentselly/immodossier-shared';
import { cockpitOffersWidgets } from '~/config/widgets/cockpit/cockpitOffersWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_COCKPIT_OFFERS,
  cockpitOffersWidgets,
  true,
);
